import type { Template } from "@/types";

export const PO_04_H1_V3: Template[] = [
    {
        id: "po-04-h1v3-01",
        name: "PO 01 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 249, width: 226, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 279, y: 249, width: 508, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 795, y: 249, width: 226, height: 327, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1029, y: 249, width: 226, height: 327, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-02",
        name: "PO 02 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 107, y: 102, width: 435, height: 624, rotation: 0, imageRotation: 0 },
            { id: "2", x: 756, y: 102, width: 435, height: 312, rotation: 0, imageRotation: 0 },
            { id: "3", x: 756, y: 422, width: 214, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 422, width: 214, height: 304, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-03",
        name: "PO 03 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 37, y: 0, width: 575, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 80, width: 491, height: 313, rotation: 0, imageRotation: 0 },
            { id: "3", x: 723, y: 401, width: 242, height: 342, rotation: 0, imageRotation: 0 },
            { id: "4", x: 973, y: 401, width: 241, height: 342, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-04",
        name: "PO 04 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 44, y: 249, width: 509, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 561, y: 249, width: 226, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 795, y: 249, width: 226, height: 327, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1029, y: 249, width: 225, height: 327, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-05",
        name: "PO 05 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 102, y: 113, width: 218, height: 318, rotation: 0, imageRotation: 0 },
            { id: "2", x: 102, y: 439, width: 444, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 734, y: 68, width: 478, height: 691, rotation: 0, imageRotation: 0 },      
            { id: "4", x: 328, y: 113, width: 218, height: 318, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-06",
        name: "PO 06 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_06.png",
        size: [1298, 827],
        style: {},
        slots: [       
            { id: "1", x: 50, y: 282, width: 177, height: 263, rotation: 0, imageRotation: 0 },
            { id: "2", x: 235, y: 282, width: 177, height: 263, rotation: 0, imageRotation: 0 },
            { id: "3", x: 420, y: 282, width: 177, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 239, width: 548, height: 350, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-07",
        name: "PO 07 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 41, y: 249, width: 224, height: 321, rotation: 0, imageRotation: 0 },
            { id: "2", x: 273, y: 141, width: 336, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 273, y: 363, width: 224, height: 321, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 0, width: 579, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-08",
        name: "PO 08 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_08.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 91, y: 187, width: 162, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 91, y: 417, width: 162, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 261, y: 187, width: 326, height: 451, rotation: 0, imageRotation: 0 },
            { id: "4", x: 595, y: 187, width: 611, height: 451, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-09",
        name: "PO 09 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_09.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 46, y: 249, width: 226, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 280, y: 249, width: 225, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 513, y: 249, width: 225, height: 327, rotation: 0, imageRotation: 0 },
            { id: "4", x: 746, y: 249, width: 509, height: 327, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-10",
        name: "PO 10 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 64, y: 62, width: 1001, height: 702, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1073, y: 62, width: 162, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1073, y: 299, width: 162, height: 229, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1073, y: 536, width: 162, height: 228, rotation: 0, imageRotation: 0 }
        ],
    }
];